{"id":"Card","prefabs":{"default":{"children":[{"component":"Card","options":"options:*"}]}}}